function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { utils, enhancedLocalStorage, DEFAULT_PIN, PORTKEYAA } from '@aelf-web-login/wallet-adapter-base';
import { CommonBaseModal, PortkeyLoading, SignIn, Unlock, TelegramPlatform } from '@portkey/did-ui-react';
import '@portkey/did-ui-react/dist/assets/index.css';
import { Modal, Button, Typography, Drawer } from 'antd';
import useTelegram from "./useTelegram";
import "./ui.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var defaultPropsForSocialDesign = {
  titleForSocialDesign: 'Crypto wallet',
  iconSrcForSocialDesign: 'data:image/svg+xml;base64,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'
};
var constant = {
  leftImg: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImRpcmVjdGlvbi9sZWZ0Ij4KPGcgaWQ9IlVuaW9uIj4KPHBhdGggZD0iTTcuOTA5NjUgMTIuMDAyMkwxNS40NDc0IDE5LjU0QzE1LjU2NDYgMTkuNjU3MSAxNS41NjQ2IDE5Ljg0NzEgMTUuNDQ3NCAxOS45NjQzTDE0LjM4NjggMjEuMDI0OUMxNC4yNjk2IDIxLjE0MjEgMTQuMDc5NiAyMS4xNDIxIDEzLjk2MjUgMjEuMDI0OUw1LjQ2OTY3IDEyLjUzMjFDNS4xNzY3OCAxMi4yMzkyIDUuMTc2NzggMTEuNzY0MyA1LjQ2OTY3IDExLjQ3MTRMMTMuOTYzNSAyLjk3ODQ5QzE0LjA4MDcgMi44NjEzNCAxNC4yNzA2IDIuODYxMzQgMTQuMzg3OCAyLjk3ODQ5TDE1LjQ0ODUgNC4wMzkxNUMxNS41NjU2IDQuMTU2MzEgMTUuNTY1NiA0LjM0NjI2IDE1LjQ0ODUgNC40NjM0Mkw3LjkwOTY1IDEyLjAwMjJaIiBmaWxsPSIjNTE1QTYyIi8+CjwvZz4KPC9nPgo8L3N2Zz4K',
  rightImg: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24gLyBMaW5lIC8gTGVmdCYjMjI5OyYjMTY0OyYjMTM1OyYjMjI4OyYjMTg3OyYjMTg5OyI+CjxwYXRoIGlkPSJTaGFwZSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDExLjEzOThWMTAuMTAzNkMzIDEwLjAzMzIgMy4wMjkzIDkuOTY2ODQgMy4wNzczNCA5LjkyNTM5TDcuNjY2NDEgNi4wMDAyNkwzLjA3NzM0IDIuMDc1MTNDMy4wMjkzIDIuMDMzNjggMyAxLjk2NzM3IDMgMS44OTY5VjAuODYwNzAzQzMgMC43NzA4OTkgMy4wODY3MiAwLjcxODM5OCAzLjE0ODgzIDAuNzcwODk5TDguODQ1MzEgNS42NDI0M0M5LjA1MTU2IDUuODE5MjcgOS4wNTE1NiA2LjE4MTI1IDguODQ1MzEgNi4zNTY3MkwzLjE0ODgzIDExLjIyODJDMy4wODY3MiAxMS4yODIxIDMgMTEuMjI5NiAzIDExLjEzOThaIiBmaWxsPSIjNTE1QTYyIi8+CjwvZz4KPC9zdmc+Cg==',
  closeImg: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InN1Z2dlc3QvY2xvc2UiPgo8ZyBpZD0iVW5pb24iPgo8cGF0aCBkPSJNNC42MDgwNyAxNi42Mjg0QzQuNTEwNDQgMTYuNzI2IDQuMzUyMTUgMTYuNzI2IDQuMjU0NTIgMTYuNjI4NEwzLjM3MDY0IDE1Ljc0NDVDMy4yNzMwMSAxNS42NDY4IDMuMjczMDEgMTUuNDg4NSAzLjM3MDY0IDE1LjM5MDlMOC43NjIyOSA5Ljk5OTI2TDMuMzcwNTkgNC42MDc1NkMzLjI3Mjk2IDQuNTA5OTMgMy4yNzI5NiA0LjM1MTY0IDMuMzcwNTkgNC4yNTQwMUw0LjI1NDQ3IDMuMzcwMTJDNC4zNTIxIDMuMjcyNDkgNC41MTAzOSAzLjI3MjQ5IDQuNjA4MDIgMy4zNzAxMkw5Ljk5OTczIDguNzYxODNMMTUuMzkxNSAzLjM3MDFDMTUuNDg5MSAzLjI3MjQ3IDE1LjY0NzQgMy4yNzI0NyAxNS43NDUgMy4zNzAxTDE2LjYyODkgNC4yNTM5OEMxNi43MjY1IDQuMzUxNjEgMTYuNzI2NSA0LjUwOTkgMTYuNjI4OSA0LjYwNzU0TDExLjIzNzIgOS45OTkyNkwxNi42Mjg4IDE1LjM5MDlDMTYuNzI2NSAxNS40ODg2IDE2LjcyNjUgMTUuNjQ2OSAxNi42Mjg4IDE1Ljc0NDVMMTUuNzQ1IDE2LjYyODRDMTUuNjQ3MyAxNi43MjYgMTUuNDg5IDE2LjcyNiAxNS4zOTE0IDE2LjYyODRMOS45OTk3MyAxMS4yMzY3TDQuNjA4MDcgMTYuNjI4NFoiIGZpbGw9IiM1MTVBNjIiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=',
  connectWallet: 'Connect Wallet'
};
var defaultProps = {
  title: 'Are you sure you want to exit your wallet?',
  subTitle: ['Your current wallet and assets will be removed from this app permanently. This action cannot be undone.', 'You can ONLY recover this wallet with your guardians.'],
  okTxt: 'I Understand, Confirm Exit',
  cancelTxt: 'Cancel',
  visible: false,
  onOk: function onOk() {
    return void 0;
  },
  onCancel: function onCancel() {
    return void 0;
  },
  width: 430,
  mobileWidth: 343
};
var isMobile = utils.isMobile;
var ConfirmLogoutDialog = function ConfirmLogoutDialog(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    title = _defaultProps$props.title,
    subTitle = _defaultProps$props.subTitle,
    okTxt = _defaultProps$props.okTxt,
    cancelTxt = _defaultProps$props.cancelTxt,
    visible = _defaultProps$props.visible,
    onOk = _defaultProps$props.onOk,
    onCancel = _defaultProps$props.onCancel,
    width = _defaultProps$props.width,
    mobileWidth = _defaultProps$props.mobileWidth;
  var isMobileDevice = isMobile();
  return /*#__PURE__*/_jsx(Modal, {
    footer: null,
    open: visible,
    width: isMobileDevice ? mobileWidth : width,
    onCancel: onCancel,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "aelf-web-logout-dialog-title-wrap",
          children: /*#__PURE__*/_jsx("div", {
            className: "aelf-web-logout-dialog-title",
            children: title
          })
        }), /*#__PURE__*/_jsx("div", {
          children: subTitle === null || subTitle === void 0 ? void 0 : subTitle.map(function (t) {
            return /*#__PURE__*/_jsx("div", {
              className: "aelf-web-logout-dialog-sub-title aelf-web-logout-dialog-mt-12",
              children: t
            }, t);
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "aelf-web-logout-dialog-btn-wrap",
        children: [/*#__PURE__*/_jsx(Button, {
          type: "primary",
          danger: true,
          onClick: onOk,
          children: okTxt
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          ghost: true,
          onClick: onCancel,
          children: cancelTxt
        })]
      })]
    })
  });
};
var DynamicWrapper = function DynamicWrapper(_ref) {
  var children = _ref.children,
    onCloseHandler = _ref.onCloseHandler,
    noCommonBaseModal = _ref.noCommonBaseModal;
  return noCommonBaseModal ? /*#__PURE__*/_jsx("div", {
    children: children
  }) : /*#__PURE__*/_jsx(CommonBaseModal, {
    destroyOnClose: true
    // className={clsx('portkey-ui-sign-modal', `portkey-ui-sign-modal-${portkeyOpts.design}`)}
    // maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
    ,
    open: true,
    onClose: onCloseHandler,
    children: children
  });
};
var NestedModal = function NestedModal(_ref2) {
  var open = _ref2.open,
    onClose = _ref2.onClose,
    validWallets = _ref2.validWallets,
    design = _ref2.design,
    bridgeInstance = _ref2.bridgeInstance;
  var isMobileDevice = isMobile();
  var isWeb2Design = design === 'Web2Design';
  var validWalletList = validWallets.map(function (wallet) {
    return /*#__PURE__*/_jsxs("div", {
      className: "nested-wallet-wrapper",
      onClick: function onClick() {
        return bridgeInstance.onUniqueWalletClick(wallet.name);
      },
      children: [/*#__PURE__*/_jsx("img", {
        src: wallet.icon
      }), /*#__PURE__*/_jsx(Typography.Text, {
        children: wallet.name
      })]
    }, wallet.name);
  });
  return isMobileDevice ? /*#__PURE__*/_jsx(Drawer, {
    className: "aelf-web-conntect-drawer",
    title: /*#__PURE__*/_jsxs("div", {
      className: "nested-drawer-title-wrapper",
      children: [/*#__PURE__*/_jsx("span", {
        className: "title",
        children: "Connect Wallet"
      }), /*#__PURE__*/_jsx("img", {
        src: constant.closeImg,
        onClick: onClose
      })]
    }),
    getContainer: false,
    closeIcon: null,
    onClose: onClose,
    prefixCls: "portkey-ant-drawer",
    open: open,
    placement: 'bottom',
    children: /*#__PURE__*/_jsx("div", {
      className: "nested-entry-wrapper nested-entry-wrapper-mobile",
      children: validWalletList
    })
  }) : /*#__PURE__*/_jsx(Modal, {
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "aelf-web-logout-dialog-title ".concat(isWeb2Design ? 'nested-title-12' : 'nested-title'),
        children: constant.connectWallet
      }), isWeb2Design ? /*#__PURE__*/_jsx("img", {
        className: "nested-close-icon",
        src: constant.closeImg,
        onClick: onClose
      }) : /*#__PURE__*/_jsx("img", {
        className: "nested-left-icon",
        src: constant.leftImg,
        onClick: onClose
      })]
    }),
    getContainer: false,
    open: open,
    closable: false,
    footer: null,
    centered: true,
    className: "nested-connect-modal",
    prefixCls: "portkey-ant-modal",
    width: 430,
    children: /*#__PURE__*/_jsx("div", {
      className: "nested-entry-wrapper",
      children: validWalletList
    })
  });
};
var SignInModal = function SignInModal(props) {
  var bridgeInstance = props.bridgeInstance,
    wallets = props.wallets,
    baseConfig = props.baseConfig;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowWrapper = _useState2[0],
    setIsShowWrapper = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isShowLockPanel = _useState6[0],
    setIsShowLockPanel = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    password = _useState8[0],
    setPassword = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isWrongPassword = _useState10[0],
    setIsWrongPassword = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isShowConfirmLogoutPanel = _useState12[0],
    setIsShowConfirmLogoutPanel = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isShowNestedModal = _useState14[0],
    setIsShowNestedModal = _useState14[1];
  var _useTelegram = useTelegram(baseConfig.chainId, baseConfig.networkType, bridgeInstance, setIsShowWrapper),
    handleTelegram = _useTelegram.handleTelegram,
    currentLifeCircle = _useTelegram.currentLifeCircle;
  var filteredWallets = wallets.filter(function (ele) {
    return ele.name !== PORTKEYAA;
  });
  var isMobileDevice = isMobile();
  var _baseConfig$noCommonB = baseConfig.noCommonBaseModal,
    noCommonBaseModal = _baseConfig$noCommonB === void 0 ? false : _baseConfig$noCommonB,
    SignInComponent = baseConfig.SignInComponent,
    CustomizedConfirmLogoutDialog = baseConfig.ConfirmLogoutDialog;
  var FinalSignInComponent = SignInComponent || SignIn;
  var FinalConfirmLogoutDialog = CustomizedConfirmLogoutDialog || ConfirmLogoutDialog;
  // const isLocking = store.getState().isLocking;
  // console.log('isLocking', isLocking);

  useEffect(function () {
    if (!TelegramPlatform.isTelegramPlatform()) {
      return;
    }
    console.log('begin to init and execute handleTelegram', TelegramPlatform.isTelegramPlatform());
    var handleLogout = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return bridgeInstance.onPortkeyAAUnLock(DEFAULT_PIN);
            case 2:
              _context.next = 4;
              return bridgeInstance.doubleCheckDisconnect();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleLogout() {
        return _ref3.apply(this, arguments);
      };
    }();
    TelegramPlatform.initializeTelegramWebApp({
      handleLogout: handleLogout
    });
    function autoAuthInTelegram() {
      return _autoAuthInTelegram.apply(this, arguments);
    }
    function _autoAuthInTelegram() {
      _autoAuthInTelegram = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('begin to excute autoAuthInTelegram');
              if (!(enhancedLocalStorage.getItem('connectedWallet') === PORTKEYAA)) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return bridgeInstance.onPortkeyAAUnLock(DEFAULT_PIN);
            case 4:
              return _context2.abrupt("return");
            case 5:
              console.log('begin to excute handleTelegram');
              handleTelegram();
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _autoAuthInTelegram.apply(this, arguments);
    }
    autoAuthInTelegram();
  }, [bridgeInstance, handleTelegram]);
  bridgeInstance.autoLogin = function () {
    handleTelegram();
  };
  bridgeInstance.openLoginPanel = function () {
    setIsShowWrapper(true);
  };
  bridgeInstance.closeLoginPanel = function () {
    setIsShowWrapper(false);
  };
  bridgeInstance.openLoadingModal = function () {
    setLoading(true);
  };
  bridgeInstance.closeLoadingModal = function () {
    setLoading(false);
  };
  bridgeInstance.openLockPanel = function () {
    setIsShowLockPanel(true);
  };
  bridgeInstance.closeLockPanel = function () {
    setIsShowLockPanel(false);
  };
  bridgeInstance.openConfirmLogoutPanel = function () {
    setIsShowConfirmLogoutPanel(true);
  };
  bridgeInstance.closeConfirmLogoutPanel = function () {
    setIsShowConfirmLogoutPanel(false);
  };
  bridgeInstance.closeNestedModal = function () {
    setIsShowNestedModal(false);
  };
  var onFinishInternal = useCallback(function (didWallet) {
    bridgeInstance.onPortkeyAAWalletLoginFinished(didWallet);
  }, [bridgeInstance]);
  var onCloseWrapperInternal = useCallback(function () {
    setIsShowNestedModal(false);
    setIsShowWrapper(false);
  }, []);
  var confirmLogoutHandler = useCallback(function () {
    bridgeInstance.doubleCheckDisconnect();
  }, [bridgeInstance]);
  var cancelLogoutHandler = useCallback(function () {
    bridgeInstance.closeConfirmLogoutPanel();
  }, [bridgeInstance]);
  var onUnlockInternal = useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(pin) {
      var success;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return bridgeInstance.onPortkeyAAUnLock(pin);
          case 2:
            success = _context3.sent;
            if (!success) {
              setIsWrongPassword(true);
              if (isMobileDevice && baseConfig.keyboard) {
                setPassword('');
              }
            } else {
              setIsWrongPassword(false);
              setPassword('');
            }
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [baseConfig.keyboard, bridgeInstance, isMobileDevice]);
  var extraWallets = useMemo(function () {
    if (baseConfig.design === 'SocialDesign') {
      return /*#__PURE__*/_jsxs("div", {
        className: "aelf-web-extra-wallets-wrapper-social",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "social-design-wallets",
          children: [/*#__PURE__*/_jsx("div", {
            className: "title-icon",
            children: /*#__PURE__*/_jsx("img", {
              src: (baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.iconSrcForSocialDesign) || defaultPropsForSocialDesign.iconSrcForSocialDesign
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "aelf-web-logout-dialog-title",
            children: (baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.titleForSocialDesign) || defaultPropsForSocialDesign.titleForSocialDesign
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "social-design-wallets",
          children: filteredWallets.map(function (item) {
            return /*#__PURE__*/_jsxs("div", {
              className: "social-design-wallet-wrapper",
              onClick: function onClick() {
                return bridgeInstance.onUniqueWalletClick(item.name);
              },
              children: [/*#__PURE__*/_jsx("img", {
                src: item.icon
              }), /*#__PURE__*/_jsx("div", {
                className: "aelf-web-logout-dialog-sub-title",
                children: item.name
              })]
            }, item.name);
          })
        })]
      });
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "aelf-web-extra-wallets-wrapper-crypto",
          children: [/*#__PURE__*/_jsx(Typography.Text, {
            className: "crypto-wallets-title",
            children: "Crypto wallet"
          }), /*#__PURE__*/_jsxs("div", {
            className: "crypto-extra-wallets ".concat(baseConfig.design === 'Web2Design' && 'web2-extra-wallets'),
            onClick: function onClick() {
              setIsShowNestedModal(true);
            },
            children: [/*#__PURE__*/_jsx(Typography.Text, {
              className: "crypto-extra-wallets-left",
              children: constant.connectWallet
            }), /*#__PURE__*/_jsxs("div", {
              className: "crypto-extra-image",
              children: [filteredWallets.map(function (item) {
                return /*#__PURE__*/_jsx("img", {
                  src: item.icon
                }, item.name);
              }), /*#__PURE__*/_jsx("img", {
                className: "crypto-extra-image-arrow",
                src: constant.rightImg
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(NestedModal, {
          open: isShowNestedModal,
          onClose: function onClose() {
            setIsShowNestedModal(false);
          },
          design: baseConfig.design,
          bridgeInstance: bridgeInstance,
          validWallets: filteredWallets
        })]
      });
    }
  }, [baseConfig.design, baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.iconSrcForSocialDesign, baseConfig === null || baseConfig === void 0 ? void 0 : baseConfig.titleForSocialDesign, bridgeInstance, filteredWallets, isShowNestedModal]);
  return (
    /*#__PURE__*/
    // <PortkeyProvider networkType={baseConfig.networkType} theme="dark">
    _jsxs("div", {
      children: [!isShowWrapper ? null : isShowLockPanel ? /*#__PURE__*/_jsx(Unlock, {
        className: "web-login-unlock-wrapper",
        open: true,
        value: password,
        isWrongPassword: isWrongPassword,
        keyboard: baseConfig.keyboard,
        onChange: setPassword,
        onCancel: onCloseWrapperInternal,
        onUnlock: onUnlockInternal
      }) : /*#__PURE__*/_jsx(DynamicWrapper, {
        onCloseHandler: onCloseWrapperInternal,
        noCommonBaseModal: noCommonBaseModal,
        children: /*#__PURE__*/_jsx(FinalSignInComponent, {
          pin: TelegramPlatform.isTelegramPlatform() ? DEFAULT_PIN : undefined,
          defaultLifeCycle: currentLifeCircle,
          defaultChainId: baseConfig.chainId,
          uiType: "Full",
          design: baseConfig.design,
          isShowScan: true,
          extraElementList: [extraWallets],
          onCancel: function onCancel() {
            //TODO: seem to not execute
            console.log('onSignInCancel');
          },
          onError: function onError() {
            console.log('onSignInInternalError');
          },
          onFinish: onFinishInternal
        })
      }), /*#__PURE__*/_jsx(FinalConfirmLogoutDialog, {
        visible: isShowConfirmLogoutPanel,
        onOk: confirmLogoutHandler,
        onCancel: cancelLogoutHandler
      }), /*#__PURE__*/_jsx(PortkeyLoading, {
        loading: loading
      })]
    })
    // </PortkeyProvider>
  );
};
export default SignInModal;